export default {
	title: 'sensor_settings',
	components: [
		{ title: 'dark_threshold', component: 'dark_threshold_g2' },
		{ title: 'bright_threshold', component: 'bright_threshold_g2' },
	],
};
